// extracted by mini-css-extract-plugin
module.exports = {"footerWrap":"footerStyles-module--footerWrap--2LbCe","contact":"footerStyles-module--contact--2v08B"};